import SimplePage from "@/components/layout/SimplePage";
import RichHtml from "@/components/RichHtml";
import { useContent } from "@/hooks/useContent";

const FALLBACK = `
  <p>The TIOB Men&rsquo;s Club is an informal fraternity of men in our community who gather for breakfasts,
     holiday helper duties, service projects, and simple time together.</p>
  <h2>What We Do</h2>
  <ul>
    <li>Sunday morning breakfasts &mdash; bagels, lox, eggs, coffee, and conversation</li>
    <li>Holiday helpers &mdash; setting up the sukkah, running Purim carnival, hauling tables for the seder</li>
    <li>Service & social action projects partnering with Sisterhood and Social Action</li>
    <li>Monthly minyan for those observing yahrzeit</li>
  </ul>
  <p>Every man in our community is already a member &mdash; no separate fee. Contact Harold Simmons or the
     temple office to be added to the Men&rsquo;s Club email list.</p>
  <p><strong>Contact:</strong> <a href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a> &middot;
     <a href="tel:+13216319494">(321) 631-9494</a></p>
`;

export default function MensClub() {
  const { body } = useContent("mens_club.body", FALLBACK);
  return (
    <SimplePage
      title="Men's Club at Temple Israel of Brevard"
      eyebrow="Brotherhood at TIOB"
      subtitle="Breakfasts, service projects, and Jewish fraternity - the TIOB Men's Club welcomes every man in our community."
      description="The Men's Club at Temple Israel of Brevard hosts breakfasts, holiday helpers, and volunteer service projects for members and guests."
      path="/about/mens-club"
      ctaLabel="Contact the Men's Club"
    >
      <RichHtml html={body} fallback={<div dangerouslySetInnerHTML={{ __html: FALLBACK }} />} />
    </SimplePage>
  );
}
